import React from 'react';

import kediOturan from 'assets/img/home/kedi-oturan.png';
import { PHONICS_LETTERS, PHONICS_FEATURES } from './homeContent';

// "Ses Bilgisi" (phonics) module card on the home page.
const PhonicsShowcase = () => (
  <div className="op-phonics__card">
    <div className="op-phonics__copy">
      <span className="op-kicker op-kicker--red">
        <span className="op-announce__tag">Yeni</span> Ses temelli okuma
      </span>
      <h2>Ses Bilgisi ile okumaya sesten başlayın</h2>
      <p>
        Okul öncesi ve 1. sınıflar için ses temelli okuma yöntemine
        uygun yeni modülümüz. Öğrenciler sesleri kitaplarla keşfeder,
        öğretmenler her ses için sınıfına özel materyal setleri hazırlar.
      </p>
      <ul className="op-phonics__list">
        {PHONICS_FEATURES.map((feature) => (
          <li key={feature.title}>
            <span className="op-phonics__icon" aria-hidden="true">
              {feature.icon}
            </span>
            <div>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </div>
          </li>
        ))}
      </ul>
      <p className="op-phonics__note">
        Ses Bilgisi modülü okulunuz için etkinleştirildiğinde okul öncesi
        ve 1. sınıf hesaplarında görünür.
      </p>
      <a className="op-btn op-btn--accent" href="/contact">
        Okulunuz için bilgi alın
      </a>
    </div>
    <div className="op-phonics__visual" aria-hidden="true">
      <ul className="op-phonics__tiles">
        {PHONICS_LETTERS.map((tile) => (
          <li key={tile.letter} style={{ background: tile.color, color: tile.ink }}>
            <span className="op-phonics__letter">{tile.letter}</span>
            <span className="op-phonics__sound">/{tile.letter}/</span>
          </li>
        ))}
      </ul>
      <img className="op-phonics__cat" src={kediOturan} alt="" />
    </div>
  </div>
);

export default PhonicsShowcase;
